import React, { useEffect } from 'react';
import useModal from '@/hooks/useModal';
import { ModalHeader } from '@/components/modals/ModalHeader';
import { Typography } from '../../common/typography/typography';
import { StatusTypes } from '@/interfaces';

interface Props {
	status: StatusTypes | undefined;
	action: string;
}

export const ModalCaseExpires: React.FC<Props> = ({ status, action }) => {
	const { Modal, show } = useModal();
	const expireStatus: StatusTypes[] = [
		'Aborted',
		'Cancelled',
		'Case Aborted',
		'Case Resolved',
		'Resolved Case',
		'Case Unsuccessful',
	];
	const dirStatus = {
		Aborted: 'aborted',
		Cancelled: 'cancelled',
		'Case Aborted': 'aborted',
		'Case Unsuccessful': 'unsuccessful',
		'Resolved Case': 'resolved',
	};

	useEffect(() => {
		if (status && expireStatus.includes(status) && action) {
			show();
		}
	}, [status]);

	return (
		<Modal withXButton classNameCardContainer="!w-[532px]">
			<ModalHeader title="No Further Action Required" />
			<div className="space-y-1 mt-8">
				<Typography type="regular-16">
					{`Your case has been ${dirStatus[status as keyof typeof dirStatus]}.`}
				</Typography>
				<Typography type="regular-16">
					{`Please check your email for further details.`}
				</Typography>
			</div>
		</Modal>
	);
};
